import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "security-app/components/common/Modal";
import AlertDetails from "./AlertDetails";
function SystemAlertsDetails({ notifications, onClose }) {
  const { t } = useTranslation("enterprise_security_app");
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      onConfirm: onClose,
      confirmText: t("system_alerts_details.dismiss"),
      noCancelButton: true,
      title: t("system_alerts_details.title")
    },
    notifications.map((notification) => /* @__PURE__ */ React.createElement(AlertDetails, { key: uuidv4(), notification }))
  );
}
export default SystemAlertsDetails;
